import Tab from 'apollo-react/components/Tab';
import Tabs from 'apollo-react/components/Tabs';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import ErrorDisplay from '../../components/ErrorDisplay';
import { ERRORS } from '../../constants/Common';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { ERROR_CONTAINER_FLEX_BASIS } from '../../form-designer/constants/runtime.constants';
import { getErrorDisplayMessages } from '../../selectors/MessagesSelectors';

function ErrorContainer() {
  const [currentTab, setCurrentTab] = useState(0);
  const tabContent = [<ErrorDisplay key={0} />];
  const errors = useSelector(getErrorDisplayMessages);

  const translateString = useTranslation();
  const errorsTitle = translateString(ERRORS);

  const handleTabChange = (ev, tabValue) => {
    setCurrentTab(tabValue);
  };

  return errors.length > 0 ? (
    <div
      style={{
        padding: 24,
        flex: `0 0 ${ERROR_CONTAINER_FLEX_BASIS}px`,
        height: 'calc(100vh - 64px)',
        overflowY: 'auto',
      }}
      ui-ta="ScrollingElement"
    >
      <Tabs style={{ marginBottom: 20 }} value={currentTab} onChange={handleTabChange}>
        <Tab label={`${errorsTitle} (${errors.length})`} disabled={errors.length < 1} />
      </Tabs>
      {tabContent[currentTab]}
    </div>
  ) : null;
}

export default ErrorContainer;
